import { Component, Input, ContentChildren, TemplateRef, QueryList } from '@angular/core';
const moment = require('moment');


export class SkyListToolbarItemComponent {
   public id: string = moment().toDate().getTime().toString();
   public index: number = -1;
   public location: string = 'left';
   private templates: QueryList<TemplateRef<any>>;
  public get template(): TemplateRef<any> {
    return this.templates.length > 0 ? this.templates.first : undefined;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-toolbar-item',
  template: '<ng-content></ng-content>'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'index': [{ type: Input },],
'location': [{ type: Input },],
'templates': [{ type: ContentChildren, args: [TemplateRef, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
